import {
  GetUserLocationResponse,
  getUserLocation,
} from '@otter-ai/recall-client';
import { HOUR_MS } from '#constants';
import { AdditionalQueryOptions } from '#utils';

const userLocationQueryKey = ['userLocation'] as const;
type UserLocationQueryKey = typeof userLocationQueryKey;

type LocationDetails = GetUserLocationResponse['location_details'];

const staleTime = 24 * HOUR_MS;

type AdditionalUserLocationQueryOptions = AdditionalQueryOptions<
  LocationDetails,
  UserLocationQueryKey
>;

export type UserLocationQuery = {
  readonly queryKey: UserLocationQueryKey;
  readonly queryFn: () => Promise<LocationDetails>;
} & AdditionalUserLocationQueryOptions;

/**
 * Create a query to fetch the user's location details
 *
 * @example
 * ```tsx
 * * const { data: userLocation } = useQuery(userLocationQueryCreator());
 * ```
 */

export function userLocationQueryCreator(
  additionalOptions: AdditionalUserLocationQueryOptions = {},
): UserLocationQuery {
  return {
    staleTime,
    retry: 0,
    queryKey: userLocationQueryKey,
    queryFn: async () => {
      const response = await getUserLocation({ throwOnError: true });
      return response.data.location_details;
    },
    ...additionalOptions,
  };
}
